import React from 'react';
import AdminDashboardOverview from '../../../components/AuctionFeatureComponents/Admin/AdminDashboard/AdminDashboardOverview';

const AdminDashboardPage = () => {
  return (
    <div>
      <AdminDashboardOverview />
    </div>
  );
};

export default AdminDashboardPage;